export interface OAuthTokenResponse {
    access_token: string;
    refresh_token?: string;
}

export interface OAuthCallbackTokenResponse {
    access_token_response: OAuthTokenResponse;
}

export interface MsalTokenResponse {
    accessToken: string;
}

export interface RoleModule {
    RoleName: string;
}

export interface AuthPolicyResult {
    policy: string;
}

export interface AuthCallbackResult extends AuthPolicyResult {
    azureId: string;
}

export interface OAuthRedirectQueryParams extends Partial<OAuthTokenResponse> {
    state?: string;
    error?: string;
    error_description?: string;
}

export function toOAuthTokenResponse(value: OAuthTokenResponse | OAuthCallbackTokenResponse | OAuthRedirectQueryParams): OAuthTokenResponse {
    return value as OAuthTokenResponse;
}

export function toOAuthCallbackTokenResponse(value: OAuthTokenResponse | OAuthCallbackTokenResponse | OAuthRedirectQueryParams): OAuthCallbackTokenResponse {
    return value as OAuthCallbackTokenResponse;
}